import classNames from "classnames";
import "./OpticksExpanded.css";
import OpticksExpanderChevronIcon from "../OpticksIconsComponents/OpticksExpanderChevronIcon/OpticksExpanderChevronIcon";
import type { OpticksButtonSize } from "../OpticksButton/OpticksButton";

interface Props {
  children: React.ReactNode;
  isExpanded?: boolean;
  action?: { text: string; onClick: () => void; buttonSize?: OpticksButtonSize };
}

const OpticksExpanded = ({ children, isExpanded = false, action }: Props) => {
  return (
    <div className="opticks-expanded">
      {action && (
        <OpticksExpanderChevronIcon
          expanded={isExpanded}
          label={action.text}
          onClick={action.onClick}
          size={action.buttonSize}
        />
      )}
      <div
        className={classNames("opticks-expanded-content", {
          expanded: isExpanded,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default OpticksExpanded;
